import { render, staticRenderFns } from "./PasswordForgot.vue?vue&type=template&id=6202b83d"
import script from "./PasswordForgot.vue?vue&type=script&lang=js"
export * from "./PasswordForgot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports